function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { useMemo } from 'react';
export const useGtm = () => {
  const sendDataToGTM = useGTMDispatch();
  return useMemo(() => ({
    sendEventDeprecated(eventName, eventData) {
      sendDataToGTM({
        event_data: null
      }); //clear previous event_data

      sendDataToGTM({
        event: eventName,
        event_data: eventData
      });
    },

    report(eventType, label, data) {
      const eventNameWithProperties = getEventNameWithProperties(eventType, label);
      const eventDataWithProperties = getEventDataWithProperties(eventType, label, data);
      sendDataToGTM({
        event_data: null
      }); //clear previous event_data

      sendDataToGTM({
        event: eventNameWithProperties,
        event_data: eventDataWithProperties
      });
    },

    sendPageView(url, eventData) {
      sendDataToGTM({
        view_data: null,
        event_data: null
      }); //clear both previous view_data and event_data

      sendDataToGTM({
        event: 'view',
        view_data: eventData
      });
    }

  }), []);
};

const getEventNameWithProperties = (eventType, label) => "".concat(eventType, "-").concat(label);

const getEventDataWithProperties = (eventType, label, data) => {
  const [category, action] = eventType.split('-');

  const eventDataWithProperties = _objectSpread(_objectSpread({}, data), {}, {
    event_category: category,
    event_action: action,
    event_label: label
  });

  return eventDataWithProperties;
};